import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthGuard } from './components/AuthGuard';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { DashboardPage } from './pages/DashboardPage';
import { CreateFeedPage } from './pages/CreateFeedPage';
import { FeedDetailPage } from './pages/FeedDetailPage';
import { WaitlistPage } from './pages/WaitlistPage';
import { WaitlistConfirmationPage } from './pages/WaitlistConfirmationPage';
import { LandingPage } from './pages/LandingPage';

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/waitlist/confirmed" element={<WaitlistConfirmationPage />} />

        {/* Protected routes */}
        <Route element={<AuthGuard />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/feeds/new" element={<CreateFeedPage />} />
          <Route path="/feeds/:id" element={<FeedDetailPage />} />
        </Route>

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
